import { Components, createTheme, Theme } from "@mui/material/styles";

const baseTheme = createTheme();

const MuiTextField: Components<Theme>["MuiTextField"] = {
  styleOverrides: {
    root: {
      input: {
        backgroundColor: "#fcf8f4",
        "&.Mui-disabled": {
          backgroundColor: baseTheme.palette.action.disabledBackground,
          borderColor: baseTheme.palette.action.disabled,
          cursor: "default",
        },
      },
      "&.Mui-static-field": {
        pointerEvents: "none",
        input: {
          backgroundColor: "#f8f8f8",
          WebkitTextFillColor: baseTheme.palette.text.secondary,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "0",
        },
      },
    },
  },
};

export default MuiTextField;
